module.exports = __webpack_public_path__ + "5c8f4297af723db9cff658d7d5d42fa1.svg";